var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import HeaderMenuButton from "./HeaderMenuButton";
import HeaderMenuModal from "./HeaderMenuModal";
import { getPendingJoinRequests } from '../../actions/agencies';
import { getUserData } from '../../actions/users';
import { usePremiumAccess } from '../../hooks/usePremiumAccess';
var HeaderHome = function (_a) {
    var agencyName = _a.agencyName, showNoClientsTooltip = _a.showNoClientsTooltip;
    var _b = useState(false), menuOpen = _b[0], setMenuOpen = _b[1];
    var _c = useState([]), pendingRequests = _c[0], setPendingRequests = _c[1];
    var _d = useState(null), user = _d[0], setUser = _d[1];
    var navigate = useNavigate();
    // Hook centralizado: busca dados do premium/trial diretamente da API
    var _e = usePremiumAccess(), hasPremiumAccess = _e.hasPremiumAccess, isInTrialPeriod = _e.isInTrialPeriod, hasActivePlan = _e.hasActivePlan, trialDaysLeft = _e.trialDaysLeft, trialCreatedAt = _e.trialCreatedAt, isLoading = _e.isLoading;
    useEffect(function () {
        getPendingJoinRequests()
            .then(function (requests) { return setPendingRequests(requests); })
            .catch(function () { return setPendingRequests([]); });
        getUserData()
            .then(function (response) {
            setUser(response.data);
        })
            .catch(function (error) {
            console.error('Erro ao buscar dados do usuário:', error);
            setUser(null);
        });
    }, []);
    var hasWhatsappIssue = (user === null || user === void 0 ? void 0 : user.whatsapp_number) &&
        user.whatsapp_number !== "55" &&
        !user.whatsapp_notifications_active;
    var notifications = __spreadArray(__spreadArray([], pendingRequests.map(function (req) { return ({
        message: "Solicita\u00E7\u00E3o pendente para ag\u00EAncia #".concat(req.agency),
        onClick: function () { return navigate('/settings'); },
        type: 'agency'
    }); }), true), (hasWhatsappIssue ? [{
            message: 'WhatsApp não ativado para notificações',
            onClick: function () {
                navigate('/settings');
                setTimeout(function () {
                    var _a;
                    (_a = document.getElementById('conf-whatsapp')) === null || _a === void 0 ? void 0 : _a.scrollIntoView({
                        behavior: 'smooth',
                        block: 'start'
                    });
                }, 300);
            },
            type: 'whatsapp'
        }] : []), true);
    var hasPendingRequests = pendingRequests.length > 0;
    // Usa trialCreatedAt do hook, não do user
    var agencyCreatedAt = trialCreatedAt || "";
    var hasMoreThan24Hours = function (createdAt) {
        if (!createdAt)
            return false;
        var creationDate = new Date(createdAt);
        var now = new Date();
        var diffMs = now.getTime() - creationDate.getTime();
        return diffMs >= 24 * 60 * 60 * 1000;
    };
    var showTrialMessage = !hasActivePlan && isInTrialPeriod && hasMoreThan24Hours(agencyCreatedAt);
    var trialHeader = "";
    var trialCta = "";
    if (trialDaysLeft && trialDaysLeft > 3) {
        trialHeader = "Per\u00EDodo de Teste: Restam ".concat(trialDaysLeft, " ").concat(trialDaysLeft === 1 ? 'dia' : 'dias', " com clientes ilimitados.");
        trialCta = "Evitar perda de monitoramento";
    }
    else if (trialDaysLeft && trialDaysLeft > 1) {
        trialHeader = "\u26A0\uFE0F Faltam apenas ".concat(trialDaysLeft, " dias para o fim do seu teste.");
        trialCta = "Continuar monitorando todos os clientes";
    }
    else if (trialDaysLeft === 1) {
        trialHeader = "⏰ Último dia de teste! Seus clientes serão desativados amanhã.";
        trialCta = "Manter todos os clientes ativos";
    }
    // Exibe loader enquanto dados premium/trial estão carregando
    if (isLoading) {
        return (React.createElement("div", { className: "w-full flex justify-center py-6" },
            React.createElement("span", { className: "text-gray-300 text-sm" }, "Carregando informa\u00E7\u00F5es da ag\u00EAncia...")));
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("header", { className: "h-14 md:h-19 flex items-center bg-gray-900/50 relative overflow-visible pr-28 md:pr-36" },
            React.createElement("h1", { className: "flex-1 text-xl md:text-4xl font-bold tracking-wider bg-clip-text text-transparent bg-gradient-to-r from-blue-500 via-green-400 to-pink-500 leading-none text-left md:text-center pl-[5px] md:pl-0 pr-0 truncate", title: agencyName }, agencyName || "Carregando..."),
            React.createElement("div", { className: "tutorial-menu-sanduiche absolute right-3 md:right-8 top-1/2 -translate-y-1/2 flex items-center group z-30" },
                React.createElement(HeaderMenuButton, { onClick: function () { return setMenuOpen(function (open) { return !open; }); }, showNoClientsTooltip: showNoClientsTooltip, hasNotification: hasPendingRequests }),
                menuOpen && (React.createElement(HeaderMenuModal, { onClose: function () { return setMenuOpen(false); }, highlightClients: showNoClientsTooltip, notifications: notifications, isDemo: agencyName === "Agência Vision Cockpit" })))),
        showTrialMessage && (React.createElement("div", { className: "w-full flex justify-center mt-2 mb-2 z-20" },
            React.createElement("div", { className: "text-yellow-400 text-xs md:text-xs flex flex-row items-center gap-3 ".concat(trialDaysLeft === 1 ? "bg-yellow-900/80 border-2 border-yellow-400 rounded-lg p-2 shadow-lg" : "") },
                React.createElement("span", { className: "flex items-center gap-1 font-semibold" }, trialHeader),
                React.createElement("button", { className: "\n                px-3 py-0.5 font-bold rounded shadow\n                transition-all\n                ".concat(trialDaysLeft === 1
                        ? "bg-yellow-400 text-gray-900 border border-yellow-500 hover:bg-yellow-300"
                        : "bg-gradient-to-r from-yellow-400 via-orange-500 to-red-500 text-white hover:from-yellow-500 hover:to-red-600", "\n                   animate-pulse-slow\n              "), onClick: function () { return window.location.href = "/subscription"; } }, trialCta))))));
};
export default HeaderHome;
